<template>
  <div v-if="$route.name === 'ListDiss'">
    <v-tabs
      ripple
      color="primary"
      dark

    >


      <v-tab href="#tab-1" v-if="this.allowed('admin|petition|petition|petition_create_council-list', 'list')">
        Заявки на рассмотрение
      </v-tab>
      <v-tab href="#tab-2" v-if="this.allowed('admin|petition|petition|petition_create_permanent_council-list', 'list')">
        Заявки на создание
      </v-tab>
      <v-tab href="#tab-3" v-if="!!allowed('admin|petition|petition|status-list', 'list')">
        Список статусов системы
      </v-tab>
      <v-tabs-items touchless>
        <v-tab-item
          :key="1"
          :value="'tab-' + 1"
        >
          <AppList v-bind:local_admin="local_admin"></AppList>
        </v-tab-item>

        <v-tab-item
          :key="2"
          :value="'tab-' + 2"
        >
          <CouncilList v-bind:local_admin="local_admin"></CouncilList>
        </v-tab-item>

        <v-tab-item
          :key="3"
          :value="'tab-' + 3"
          v-if="!!allowed('admin|petition|petition|status-list', 'list')"
        >
          <StatusList></StatusList>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

  </div>
  <router-view :key="$route.fullPath" v-else></router-view>

</template>

<script>
    import CouncilList from '@/modules/petition/forms/list/CouncilList.vue'
    import AppList from '@/modules/petition/forms/list/AppList.vue'
    import StatusList from '@/modules/petition/forms/list/StatusList'
    import urls from "../urls.js"

    export default {
        name: "ListDiss",
        components: {CouncilList, StatusList, AppList},

        data: function () {
            return {
                local_admin: '',
            }
        },
        methods: {
            allowed(urlname, action) {
                return urls.getUrlAllowed(urlname, action)
            },


        },
        created() {

            this.local_admin = this.$route.query.local_admin;
            if (typeof this.local_admin === 'string')
                this.local_admin = this.local_admin === 'true';
            if (this.local_admin) {
                let menu = [
                    {title: 'Список заявлений', icon: 'contact_mail', router: 'ListDiss',},
                    {title: 'Подать на создание', icon: 'sync_alt', router: 'Council',}
                ];
                this.$store.commit('leftmenu/replaceItems', menu);
                // this.local_admin =
            }
        },


    }

</script>


<style scoped>

</style>
